export default __webpack_public_path__ + "static/media/AllrfpDarkInActive.66e7bb26.svg";